import { useEffect } from "react";

/**
 * Sets `document.title` for the current page. Restores nothing on unmount so
 * navigating between routes always shows the freshest title. Pair with the
 * default title in index.html for the initial paint.
 */
export const usePageTitle = (title) => {
  useEffect(() => {
    if (title && typeof document !== "undefined") {
      document.title = title;
    }
  }, [title]);
};
